import { z } from 'zod';
import { ZBaseIntegrationConfig } from './base.js';
export const SNAPCHAT_INTEGRATION_NAME = 'snapchat';
export const ZSnapchatCredentials = z.object({
    /** Snap Pixel ID — UUID, from Snapchat Ads Manager → Events Manager. */
    pixelId: z.uuid('Pixel ID must be a UUID').optional(),
    /**
     * Conversions API token — static long-lived token generated in Ads Manager →
     * Business Details → Conversions API Tokens (Organization Admin role). No
     * fixed prefix; a heuristic min length catches truncated copy-pastes.
     */
    capiToken: z.string().min(20).optional(),
});
export const ZSnapchatSettings = z.object({
    /** Default true — push PURCHASE to snaptr with client_dedup_id for CAPI dedup. */
    enableClientSide: z.boolean().optional(),
    /** Default true — send PURCHASE server-side via Conversions API v3. */
    enableServerSide: z.boolean().optional(),
});
export const ZSnapchatIntegrationConfig = ZBaseIntegrationConfig.extend(z.object({
    integrationName: z.literal(SNAPCHAT_INTEGRATION_NAME),
    category: z.literal('analytics'),
    settings: ZSnapchatSettings.optional(),
    credentials: ZSnapchatCredentials.optional(),
}).shape);
//# sourceMappingURL=snapchat.js.map